<div class="section-grade-container">
  <mat-nav-list>
    <span mat-line>
      {{ 'SECTIONS.' + section.sectionName | uppercase | translate }}
    </span>
    <snap-grade [grade]="section.grade" [showGrade]="showGrade" size="extra-small"></snap-grade>
  </mat-nav-list>
</div>
